export default "__VITE_ASSET__Dvl8ZN5d__"